import { ButtonHTMLAttributes } from 'react';

export interface ActionButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement> {
  blendColor: `after:bg-${string}`;
}

export const ActionButton = ({
  children,
  blendColor,
  disabled,
  ...rest
}: ActionButtonProps) => {
  return (
    <button
      type="button"
      disabled={disabled}
      {...rest}
      className={`${disabled ? 'opacity-[35%] cursor-not-allowed' : ''} ${
        rest.className ?? ''
      } relative rounded-none overflow-hidden h-12 px-6 bg-gray-800 hover:bg-gray-800/90 text-gray-50 transition-colors font-bold uppercase text-sm after:absolute after:-bottom-2.5 after:-right-2.5 after:h-5 after:w-5 ${blendColor} after:transform after:rotate-45`}
    >
      {children}
    </button>
  );
};

export default ActionButton;
